import React, { PureComponent } from 'react';
import { NormalizedSeries } from 'types';
// Components
import PointTooltip from './point-tooltip';
import ChartPath from './chart-path';

interface ChartSeriesProps {
  index: number;
  current: number;
  series: NormalizedSeries;
  points: [number, number][];
  range?: [number, number];
  width: number;
  height: number;
  maxPoints: number;
  hideLines?: boolean;
  hideTooltip?: boolean;
}
export default class ChartSeries extends PureComponent<ChartSeriesProps> {
  state = { points: [] };
  static defaultProps = {
    range: [0, 1],
    maxPoints: 100
  };

  render() {
    const { series, current, range, height, width, hideTooltip, maxPoints } = this.props;
    const points = series.points;
    if (!points.length) return false;

    return (
      <>
        <ChartPath
          color={series.color}
          points={points}
          width={width}
          height={height}
          range={range}
          maxPoints={maxPoints}
        />
        {!hideTooltip && (
          <PointTooltip
            series={series}
            points={points}
            current={current}
            width={width}
            height={height}
            range={range}
          />
        )}
      </>
    );
  }
}
